import ErrorPage from '@/components/error/ErrorPage';

function Error404() {
  return <ErrorPage errorCode="404" />;
}

export default Error404;
